export default {
  menuTitle: 'CPS Order List',
  pageTitle: 'CPS Order List',
  paidDate: 'Payment Time',
  startDate: 'Start Date',
  endDate: 'End Date',
  orderStatus: 'Order Status',
  commissionStatus: 'Commission Status',
  attributionType: 'Attribution Type',
  all: 'All',
  soSerial: 'Order No.',
  soSerialPlaceholder: 'Enter order number',
  soSerialSku: 'Order Item No.',
  soSerialSkuPlaceholder: 'Enter order item number',
  search: 'Search',
  export: 'Export',
  exportFailed: 'Export failed. Please try again later.',
  exportLimitExceeded: 'Exports support up to 5,000 rows. Narrow your filters and try again.',
  reset: 'Reset',
  product: 'Product',
  productIds: 'Listing ID / SKU ID',
  quantity: 'Quantity',
  productRealAmount: 'Product Paid Amount',
  commissionRate: 'Commission Rate',
  effectiveCommissionAmount: 'Effective Commission',
  attributionEffectiveAt: 'Attribution Effective Time',
  unavailableProduct: 'Product information unavailable',
  noCommission: 'No commission',
  noCommissionReason: 'No commission reason: {reason}',
  statusPending: 'Pending Settlement',
  statusProtected: 'Protected',
  statusSettled: 'Pending Payout',
  statusPaid: 'Paid Out',
  statusRefunded: 'Refunded',
  statusBanned: 'Voided',
  lifecyclePaid: 'Paid',
  lifecycleSigned: 'Signed',
  lifecycleCancelled: 'Cancelled',
  attributionCps: 'Normal',
  attributionSelfPurchase: 'Self Purchase',
  attributionProductExited: 'Product Exited',
  attributionCreatorBanned: 'Permanently Banned',
  attributionNegligible: 'Commission Too Low',
  loadFailed: 'Failed to load CPS orders',
  unknownError: 'Request failed. Please try again later.',
  businessTimezone: 'Times are shown in Africa/Nairobi'
}
